export const environment = {
  production: true,
  version: '1.3.43'
};
